import { render, staticRenderFns } from "./search-dropdown-menu.vue?vue&type=template&id=63175ade&"
import script from "./search-dropdown-menu.vue?vue&type=script&lang=js&"
export * from "./search-dropdown-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports